import {
    alpha,
    OutlinedInputProps,
    styled,
    TextField,
    TextFieldProps,
} from '@mui/material';
import React from 'react';

export const RedditTextField = styled((props: TextFieldProps) => {
    return (
        <TextField
            InputProps={
                {
                    disableUnderline: true,
                } as Partial<OutlinedInputProps>
            }
            sx={{
                input: {
                    height: '65px',
                    fontSize: '2.25rem',
                    '&::placeholder': {
                        color: '#8f8f8f',
                        opacity: 1,
                    },
                },
                label: {
                    color: '#8f8f8f !important',
                    lineHeight: '30px',
                    fontSize: '2.25rem',
                    paddingBottom: '5px',
                },
            }}
            {...props}
        />
    );
})(({ theme }) => ({
    '& .MuiFilledInput-root': {
        border: `1px solid ${theme.palette.secondary.main}`,
        overflow: 'hidden',
        color: '#222222',
        borderRadius: 4,
        backgroundColor: '#ffffff',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&.Mui-focused': {
            boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
            borderColor: theme.palette.primary.main,
            backgroundColor: '#ffffff',
        },
        '&:hover': {
            boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
            borderColor: theme.palette.primary.main,
            backgroundColor: '#ffffff',
        },
    },
}));
